// Shared password policy for administrator password resets (mirrors backend/common_passwords.py).
// Backend remains authoritative; these run the live front-end checklist with identical rules.
//
// Policy (exact): min 15, max 64 characters; no character-class requirements; must not be a
// known commonly-used / breached password. No additional hidden rules.

export const PASSWORD_MIN = 15;
export const PASSWORD_MAX = 64;

// Curated commonly used / breached passwords (lowercased). Kept identical to the backend list.
export const COMMON_PASSWORDS = new Set([
  "password", "123456", "123456789", "12345678", "qwerty", "abc123", "111111",
  "123123", "admin", "letmein", "welcome", "monkey", "dragon", "football",
  "iloveyou", "sunshine", "princess", "superman", "trustno1", "master", "shadow",
  "baseball", "starwars", "whatever", "changeme", "secret", "passw0rd", "qwertyuiop",
  "passwordpassword", "password123456", "password12345678", "passwordpassword1",
  "passw0rdpassw0rd", "aaaaaaaaaaaaaaa", "aaaaaaaaaaaaaaaa", "1111111111111111",
  "111111111111111", "0000000000000000", "000000000000000", "zzzzzzzzzzzzzzzz",
  "123456789012345", "1234567890123456", "12345678901234567", "1234567890abcdef",
  "abcdefghijklmno", "abcdefghijklmnop", "qwertyuiopasdfg", "qwertyuiopasdfgh",
  "qwertyuiop123456", "qwerty1234567890", "1q2w3e4r5t6y7u8i", "1qaz2wsx3edc4rfv",
  "qazwsxedcrfvtgby", "iloveyou12345678", "iloveyoutoomuch1", "letmein123456789",
  "welcome123456789", "welcome1welcome1", "admin12345678901", "administrator123",
  "administratoradmin", "trustno1trustno1", "monkey1234567890", "football12345678",
  "superman12345678", "princess12345678", "sunshine12345678", "changeme12345678",
  "secret1234567890", "master1234567890", "dragon1234567890", "baseball12345678",
  "whatever12345678", "starwars12345678", "passwordonetwothree", "letmeinletmein11",
  "qwertyqwertyqwerty", "abcabcabcabcabc", "abcabcabcabcabca", "123123123123123",
  "iloveyouiloveyou", "welcometoamanah1", "amanahpromotions", "amanahpromotions1",
  "amanahpromotions123",
]);

export function isCommonPassword(password) {
  return COMMON_PASSWORDS.has((password || "").toLowerCase());
}

// Returns the live checklist state for the reset form.
export function passwordChecks(password, confirm) {
  const length = (password || "").length;
  return {
    length: length >= PASSWORD_MIN && length <= PASSWORD_MAX,
    notCommon: length >= PASSWORD_MIN && !isCommonPassword(password),
    match: (password || "") !== "" && password === confirm,
  };
}

export function allValid(password, confirm) {
  const c = passwordChecks(password, confirm);
  return c.length && c.notCommon && c.match;
}

// Returns a single specific, user-facing message for the first unmet requirement (or "").
export function firstError(password, confirm) {
  const length = (password || "").length;
  if (length < PASSWORD_MIN) return `Use at least ${PASSWORD_MIN} characters (you have ${length}).`;
  if (length > PASSWORD_MAX) return `Use no more than ${PASSWORD_MAX} characters (you have ${length}).`;
  if (isCommonPassword(password)) {
    return "This password is too common or has appeared in a data breach. Please choose another.";
  }
  if ((password || "") !== confirm) return "Your two password entries must match.";
  return "";
}
